<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading">
    <div class="screen-clients-loading" v-if="loading">
      {{ loadingInfo }}<br>
      {{ loadingInfo1 }}<br>
      {{ loadingInfo2 }}
    </div>
    <div class="clients-panel">
      <div class="clients-panel-container">
        <el-row class="black-inputs">
          <el-col :span="8">
            <el-input v-model="inputSearch" placeholder="Rechercher par mots clés">
              <i class="el-icon-search el-input__icon" slot="prefix"></i>
            </el-input>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-button class="dark" type="primary" @click="showImportContact = !showImportContact">Importer des
              contacts</el-button>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-button :loading=exportIsLoading class="dark" type="primary" @click="exportClients">Exporter mes
              contacts</el-button>
          </el-col>
        </el-row>
        <el-row v-if="showImportContact">
          <el-col class="clients-importer" :span="15" :offset="9">
            <label for="csv_file">Choisir un fichier</label>
            <input type="file" id="csv_file" name="csv_file" @change="loadCSV($event)">
            <span v-if="parse_csv.length > 0">
              <span class="clients-importer-ongoing">Vous allez importer {{ parse_csv.length }} contacts</span>
              <el-button class="green" @click="importContact">Importer</el-button>
              <div class="clients-importer-format">
                <label>Format du fichier</label>
                <el-radio v-model="importType" label="guestonline">GuestOnline</el-radio>
                <el-radio v-model="importType" label="resaninja">resa.ninja</el-radio>
              </div>
            </span>
          </el-col>
        </el-row>
        <el-row class="black-inputs">
          <el-col :span="8" :offset="8" v-if="this.selection.length > 0 && !addTagDisplay">
            <el-select v-model="tagsSelected" multiple placeholder="Attribuer un label à la sélection">
              <el-option v-for="t in getAllTags" :key="t.value" :label="t.text" :value="t.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7" :offset="1" v-if="tagsSelected.length > 0">
            <el-button type="primary" @click="applyTag">Attribuer</el-button>
          </el-col>
          <el-col :span="7" :offset="17" v-if="!addTagDisplay && this.selection.length === 0">
            <el-button class="dark" type="primary" @click="addTagDisplay = true">Ajouter un label</el-button>
          </el-col>
          <el-col class="screen-clients-addTag" :span="24" v-if="addTagDisplay">
            <el-col :span="8">
              <el-input v-model="inputNewTag" placeholder="Saisissez le nouveau label"></el-input>
            </el-col>
            <el-col :span="2" :offset="1">
              <el-color-picker v-model="tagColor"></el-color-picker>
            </el-col>
            <el-col :span="6">
              <el-button class="dark" type="primary" @click="closeAddTag">Annuler</el-button>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-button type="primary" @click="addNewTag">Valider</el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="black-inputs">
          <el-col :span="24" class="screen-clients">
            <el-table ref="multipleTable" :data="getDataGridClients" @sort-change="sortByName"
              @selection-change="handleSelectionChange" @filter-change="handleFilterChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="name" label="Nom" sortable="custom" width="180">
              </el-table-column>
              <el-table-column prop="prenom" label="Prénom" sortable="custom" width="180">
              </el-table-column>
              <el-table-column prop="tel" label="Téléphone" width="180">
                <template slot-scope="scope">
                  {{ formatPhone(scope.row.tel) }}
                </template>
              </el-table-column>
              <el-table-column prop="tags" label="Label" :filters="getAllTags" filter-placement="bottom-end">
                <template slot-scope="scope">
                  <client-tag v-for="tag in scope.row.tags" :key="tag" :idTag="tag" :deletable="false"
                    :cid="scope.row.cid"></client-tag>
                </template>
              </el-table-column>
              <el-table-column label="Edition" width="140">
                <template slot-scope="scope">
                  <el-button class="dark" type="primary" @click="editClientInfos(scope.row.cid)">Editer</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 30px;">
              <el-pagination background layout="prev, pager, next" :total="getTotalClients"
                :current-page="getCurrentPage" @current-change="current_change">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import Papa from 'papaparse';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as XLSX from 'xlsx';
import { z } from 'zod';
import ClientTag from './ClientTag';

export default {
  name: 'ClientsBook',
  components: { ClientTag },
  data() {
    return {
      pagesize: 10,
      total: 0,
      inputSearch: '',
      loading: false,
      loadingInfo: '',
      loadingInfo1: '',
      loadingInfo2: '',
      fileList: [],
      addTagDisplay: false,
      tagColor: '#409EFF',
      inputNewTag: '',
      tagsSelected: [],
      selection: [],
      cidEditing: '',
      dialogVisible: false,
      parse_header: [],
      parse_csv: [],
      importType: 'guestonline',
      sortOrders: {},
      sortKey: '',
      showImportContact: false,
      sortType: '',
      sortOrder: '',
      filterTags: [],
      exportIsLoading: false
    }
  },
  created: function () {
    this.inputSearch = this.getSavedSearchClient
    this.tagColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`
    this.loadClientsPagefn()
  },
  computed: {
    ...mapGetters({
      getAllClients: 'newClients/getAllClients',
      getClientByNPC: 'newClients/getClientByNPC',
      getAllTagsData: 'infos/getAllTagsData',
      getSavedSearchClient: 'newClients/getSavedSearchClient',
      getUidPublic: 'newUsers/getUidPublic',
      getAllInfos: 'infos/getAllInfos',
      getCurrentPage: 'newClients/getCurrentPage',
      getTotalClients: 'newClients/getTotalClients',
      getClientsByPage: 'newClients/getClientsByPage',
      getDataGridClients: 'newClients/getDataGridClients'

    }),
    getAllTags: function () {
      let filterArray = []
      Object.entries(this.getAllTagsData).forEach(([idt, t]) => {
        let o = {
          text: t.name,
          value: t.id
        }
        filterArray.push(o)
      })
      return filterArray
    }
  },
  watch: {
    'inputSearch': function (val, oldVal) {
      this.setSavedSearchClient(this.inputSearch)
      this.loadClientsPagefn()
    }
  },
  methods: {
    ...mapActions({
      showHideScreenIntegration: 'displayer/showHideScreenIntegration',
      createNewTag: 'infos/createNewTag',
      updateClient: 'newClients/updateClient',
      createNewClient: 'newClients/createNewClient',
      loadClientsPage: 'newClients/loadClientsPage',
      loadClients: 'newClients/loadClients'
    }),
    ...mapMutations({
      setCidEditing: 'newClients/setCidEditing',
      setDialogEditClient: 'displayer/setDialogEditClient',
      setSavedSearchClient: 'newClients/setSavedSearchClient'
    }),
    sortByName: function (event) {
      if (event.order === null) {
        this.sortType = ''
        this.sortOrder = ''
      } else {
        this.sortType = event.prop
        this.sortOrder = event.order
      }
      this.loadClientsPagefn()
    },
    loadClientsPagefn: function (page = 1) {
      this.loadClientsPage({
        page: page,
        sort: this.sortType,
        tags: this.filterTags,
        order: this.sortOrder
      })
    },
    formatPhone: function (phone) {
      if (phone[0] !== '0' && phone[0] !== '+') {
        return `0${phone}`
      }
      return phone
    },
    current_change: function (currentPage) {
      this.loadClientsPagefn(currentPage)
    },
    handleSelectionChange: function (val) {
      this.selection = val
    },
    handleFilterChange(filters) {
      this.filterTags = filters.tags
      this.loadClientsPagefn()
    },
    editClientInfos: function (cid) {
      this.setCidEditing(cid)
      this.setDialogEditClient(true)
    },
    closeAddTag: function () {
      this.tagColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`
      this.inputNewTag = ''
      this.addTagDisplay = false
    },
    addNewTag: function () {
      if (this.inputNewTag !== '') {
        let tag = {}
        tag = {
          name: this.inputNewTag,
          id: this.inputNewTag.toLowerCase(),
          color: this.tagColor
        }
        this.createNewTag(tag).then(() => {
          this.closeAddTag()
        })
      }
    },
    applyTag: function () {
      this.selection.forEach((client) => {
        let tabTag = []
        if (client.tags !== undefined) {
          tabTag = client.tags.slice(0)
          this.tagsSelected.forEach((tag) => {
            let found = tabTag.find((st) => {
              return st === tag
            })
            if (found === undefined) tabTag.push(tag)
          })
        } else {
          tabTag = this.tagsSelected.slice(0)
        }
        let mClient = Object.assign({}, client)
        mClient.tags = tabTag
        this.updateClient(mClient)
      })
      this.tagsSelected = []
      this.$refs.multipleTable.clearSelection()
    },
    filterTag: function (value, row) {
      if (row.tags !== undefined) {
        return row.tags.find((tag) => {
          return tag === value
        })
      }
    },
    exportClients: async function () {
      this.exportIsLoading = true
      const items = await this.loadClients({ disableStore: true })

      items.forEach((item) => {
        delete item.restoid
        delete item.cid
        delete item.tags
        delete item.comment
        delete item.nameLc
        delete item.prenomLc
        delete item.id
      })
      const ws = XLSX.utils.json_to_sheet(items)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Clients')
      XLSX.writeFile(wb, `Export-base-clients-${this.getAllInfos.restoName}.xlsx`)
      this.exportIsLoading = false
    },
    createFilter: function (queryString) {
      return (client) => {
        return (client.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || client.prenom.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || client.tel.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },

    fileToDownloadCsv: function (filename, text) {
      var element = document.createElement('a')
      element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`)
      element.setAttribute('download', filename)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },

    fileToDownloadXlsx: function (filename, text) {
      var element = document.createElement('a')
      element.setAttribute('href', `data:text/xlsx,${encodeURIComponent(text)}`)
      element.setAttribute('download', filename)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },
    formatDataResaNinja: function (data) {
      if (data['name'] === undefined || data['prenom'] === undefined || data['email'] === undefined) {
        return undefined
      }
      let newContact = {
        data: {
          name: data['name'],
          prenom: data['prenom'],
          tel: data['tel'],
          email: data['email'],
          civ: data['civ'],
          comment: data['comment'],
          societe: data['societe'],
          rgpdmail: data['rgpdmail'],
          rgpdsms: data['rgpdsms'],
          countShow: data['countShow'],
          countNoShow: data['countNoShow'],
          countResa: data['countResa'],
          countCancel: data['countCancel'],
          restoid: this.getUidPublic
        }
      }
      return newContact
    },
    formatDataGuestOnline: function (data) {
      if (data['Nom'] === undefined || data['Prénom'] === undefined || data['Adresse e-mail'] === undefined) {
        return undefined
      }
      let telNum = ''
      let civ = 'M.'
      if (data['Sexe (H/F)'] === 'F') civ = 'Mme'
      if (data['Téléphone fixe'] !== '') telNum = data['Téléphone fixe']
      if (data['Téléphone portable'] !== '') telNum = data['Téléphone portable']
      let newContact = {
        data: {
          name: data['Nom'],
          prenom: data['Prénom'],
          tel: telNum,
          email: data['Adresse e-mail'],
          civ: civ,
          comment: data['Notes'],
          societe: data['Société'],
          rgpdmail: data['Accepte les mailing (O/N)'],
          rgpdsms: data['Accepte les sms (O/N)'],
          restoid: this.getUidPublic
        }
      }
      return newContact
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    chunkArray(arr, size) {
      const out = []
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
      return out
    },
    importContact: async function () {
      if (this.parse_csv.length <= 0) return

      this.showImportContact = false
      this.loading = true
      this.loadingInfo = 'Import des Données'

      let count = 0

      let testContact = {}
      if (this.importType === 'guestonline') testContact = this.formatDataGuestOnline(this.parse_csv[0])
      else testContact = this.formatDataResaNinja(this.parse_csv[0])

      if (testContact === undefined) {
        this.loading = false
        alert("Il semble que le format de fichier n'est pas supporté \nERREUR : Encodage fichier incorect")
        return
      }

      if (this.importType === 'resaninja') {
        const { errors, errorCount, parsedData } = this.validateCsvRows(this.parse_csv)

        if (errorCount > 0) {
          this.loading = false

          let errorMessage = `Il y a ${errorCount} erreur(s) dans le fichier importé :\n`

          errors.forEach((error) => {
            errorMessage += `Ligne ${error.line} : ${error.messages.join(', ')}\n`
          })

          alert(errorMessage)
          return
        }

        this.parse_csv = parsedData
      }

      const toCreate = this.parse_csv

      let totalToImport = this.parse_csv.length

      this.loadingInfo = 'Traitement des données'
      this.loadingInfo1 = `Contact crée ${(count).toString()}/${totalToImport.toString()}`

      const batches = this.chunkArray(toCreate, 10)

      for (let i = 0; i < batches.length; i++) {
        const batch = batches[i]

        this.loadingInfo = `Import des contact en cours (${totalToImport.toString()} contacts valides)`

        await Promise.all(
          batch.map(async (data) => {
            try {
              console.log('Import contact', data)
              await this.createNewClient(data)
            } finally {
              count++
              this.loadingInfo1 = `Contact crée ${(count).toString()}/${totalToImport.toString()}`
            }
          })
        )

        await this.sleep(50)
      }

      alert(`Import des contacts terminé, \n${(count).toString()} / ${totalToImport.toString()} Contacts crées`)

      this.loading = false
      this.loadingInfo = ''
      this.loadingInfo1 = ''
      this.loadingInfo2 = ''
    },

    csvJSON: function (csv) {
      let result = Papa.parse(csv, { header: true })
      return result.data
    },
    loadCSV: function (e) {
      let vm = this
      if (window.FileReader) {
        let reader = new FileReader()
        reader.readAsText(e.target.files[0], 'utf-8')
        // Handle errors load
        reader.onload = function (event) {
          let csv = event.target.result
          vm.parse_csv = vm.csvJSON(csv)
        }
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            alert("Canno't read file !")
          }
        }
      } else {
        alert('FileReader are not supported in this browser.')
      }
    },
    validateCsvRows(rows) {
      const csvRowSchema = z.object({
        name: z.string().transform(val => {
          if (val === "") return "."
          return val
        }),
        prenom: z.string().transform(val => {
          if (val === "") return "."
          return val
        }),
        email: z.email('Email invalide').or(z.literal("")).transform(val => {
          if (val === "") return "."
          return val
        }),
        tel: z.string(),
        telPreFix: z.string(),
        civ: z.enum(['M.', 'Mme', 'Mme.', 'H', 'F', ""], {
          error: 'Civilité invalide'
        }).transform(val => {
          if (val === '') return '?'
          if (val === 'M.') return 'H'
          if (val === 'Mme' || val === 'Mme.') return 'F'
          return val
        }),
        comment: z.string(),
        societe: z.string(),
        rgpdmail: z.enum(['FAUX', 'VRAI']).transform(val => {
          return val === 'VRAI'
        }).optional(),
        rgpdsms: z.enum(['FAUX', 'VRAI']).transform(val => {
          return val === 'VRAI'
        }).optional(),
        countShow: z.coerce.number(),
        countNoShow: z.coerce.number(),
        countResa: z.coerce.number(),
        countCancel: z.coerce.number(),
        clientPreFix: z.string()
      })

      const errors = []
      let errorCount = 0

      const result = rows.map((row, index) => {
        const lineNumber = index + 2 // +2 si ligne 1 = header CSV

        const result = csvRowSchema.safeParse(row)

        if (!result.success) {
          errorCount++

          if (errors.length < 3) {
            errors.push({
              line: lineNumber,
              messages: result.error.issues.map(e => e.message),
            })
          }
        }

        return {
          ...result.data,
          restoid: this.getUidPublic
        };
      }).filter((row) => {
        return row.name !== "" && row.prenom !== "" && row.email !== ""
      })

      return {
        errors,
        errorCount,
        parsedData: result
      }
    }
  }
}
</script>

<style lang="scss">
.sort-caret.ascending {
  border: 7px solid transparent !important;
  border-bottom-color: #242c45 !important;
  top: 1px !important;
}

.sort-caret.descending {
  border: 7px solid transparent !important;
  border-top-color: #242c45 !important;
  bottom: 1px !important;
}

.screen-clients .el-table .ascending .sort-caret {
  &.ascending {
    border-bottom-color: #00cec0 !important;
  }
}

.screen-clients .el-table .descending .sort-caret {
  &.descending {
    border-top-color: #00cec0 !important;
  }
}
</style>
